// Lane B11's Home widget views, registered on Home's registry (D-6, HO-18): `sync_health`, whose data
// `app/integrations/read.py` gives.

import { registerHomeWidget } from "@/views/home/widgets";
import { syncHealthWidget } from "./SyncHealth";

registerHomeWidget("sync_health", syncHealthWidget);
